import React, { useState } from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";

const DatePicker = ({ filter, setFilter }) => {
  const [value, setValue] = useState([null, null]);

  const onChange = (value) => {
    setValue(value);
    if (value && value[0] && value[1]) {
      setFilter((prev) => ({
        ...prev,
        startDate: value[0].toISOString().split("T")[0],
        endDate: value[1].toISOString().split("T")[0],
      }));
    }
  };

  const handleClear = () => {
    setValue([null, null]);
    setFilter((prevFilter) => {
      const { startDate, endDate, ...newFilter } = prevFilter;
      return newFilter;
    });
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Stylish Purple-Blue Button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          background: "#3e4396", // Theme Color
          color: "white",
          border: "none",
          padding: "12px 18px",
          fontSize: "16px",
          fontWeight: "bold",
          borderRadius: "8px",
          cursor: "pointer",
          // width: "270px",
          justifyContent: "space-between",
          boxShadow: "0px 5px 12px rgba(62, 67, 150, 0.4)", // Soft shadow
          transition: "all 0.3s ease-in-out",
        }}
      >
        <DateRangePicker
          onChange={onChange}
          value={value}
          clearIcon={null}
          calendarIcon={null}
        />
        
        {/* Stylish Clear Button */}
        {filter.startDate && filter.endDate && (
          <button
            onClick={handleClear}
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
              color: "#fff",
              borderRadius: "50%",
              width: "28px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "background 0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.background = "rgba(255, 255, 255, 0.4)")}
            onMouseLeave={(e) => (e.target.style.background = "rgba(255, 255, 255, 0.2)")}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default DatePicker;
